import React, {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios as defaultAxios} from "../../lib/axios.js";
import {axios} from "../../lib/axios.js";
import {request} from "../../utils/request/index.js";
import {notification} from "../../../__snowpack__/pkg/antd.js";
import {handleError} from "../../lib/errorHandler.js";
export const useBlibliCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (channel) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas//shop/get-categories`, {
        channel
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    channelCategoriesLoading: loading,
    channelCategories: data,
    fetchChannelCategories: fetchData
  };
};
export const useBlibliCategoriesModel = createModel(useBlibliCategories);
export const useGetBrandsByChannel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (param) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.get(`/saas/product-brand/channels/get-brands-by-channel`, {
        params: param
      });
      let newData = data2.map((data3) => {
        data3.label1 = data3.label;
        data3.label = data3.value;
        data3.value = data3.label1;
        return data3;
      });
      setData(newData);
      return newData;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliBrandsLoading: loading,
    blibliBrands: data,
    fetchBlibliBrands: fetchData
  };
};
export const useGetBrandsByChannelModel = createModel(useGetBrandsByChannel);
export const getSaasShopLogisticsShop = () => {
  const [data, setData] = useState({});
  const [dataAll, setDataAll] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (shopIds, shopId) => {
    setLoading(true);
    try {
      let promiseAll = [];
      if (shopIds && shopIds.length) {
        shopIds.forEach((data2) => {
          promiseAll.push(defaultAxios.get(`/saas/shop/logistics-shop/${data2}`, {
            params: {}
          }));
        });
        const resultData = await Promise.all(promiseAll);
        let promiseMap = {};
        let promiseAllMap = {};
        resultData.forEach((reData, reIndex) => {
          promiseAllMap[shopIds[reIndex]] = reData.data;
          promiseMap[shopIds[reIndex]] = reData.data.map((obj) => {
            return {
              label: obj.name,
              enabled: obj.enabled,
              value: obj.externalLogisticsChannelId
            };
          });
        });
        setData(promiseMap);
        setDataAll(promiseAllMap);
        return {
          blibliLogisticsLoading: loading,
          blibliLogistics: data,
          blibliLogisticsAll: setDataAll,
          fetchBlibliLogistics: fetchData
        };
      } else if (shopId) {
        let defaultData = await defaultAxios.get(`/saas/shop/logistics-shop/${shopId}`, {
          params: {}
        });
        let promiseMap = {};
        let promiseAllMap = {};
        promiseAllMap[shopId] = defaultData.data;
        promiseMap[shopId] = defaultData.data.map((obj) => {
          return {
            label: obj.name,
            value: obj.externalLogisticsChannelId
          };
        });
        setData(promiseMap);
        setDataAll(promiseAllMap);
        return {
          blibliLogisticsLoading: loading,
          blibliLogistics: data,
          blibliLogisticsAll: setDataAll,
          fetchBlibliLogistics: fetchData
        };
      } else {
        setData({});
        setDataAll({});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliLogisticsLoading: loading,
    blibliLogistics: data,
    blibliLogisticsAll: setDataAll,
    fetchBlibliLogistics: fetchData
  };
};
export const getSaasShopLogisticsShopModel = createModel(getSaasShopLogisticsShop);
export const getWarehouseChannel = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [warehouseAllMap, setWarehouseAllMap] = useState({});
  const fetchData = async (shopIds, shopId) => {
    setLoading(true);
    try {
      let promiseAll = [];
      if (shopIds && shopIds.length) {
        let promiseMap = {};
        shopIds.forEach((data2) => {
          promiseAll.push(defaultAxios.post(`/saas/shop/get-shop-warehouse-by-channel-shop`, {
            shopId: data2,
            channel: "BLIBLI_ID"
          }));
        });
        const resultData = await Promise.all(promiseAll);
        let newWarehouseAllMap = {};
        resultData.forEach((reData, reIndex) => {
          promiseMap[shopIds[reIndex]] = reData.data;
          reData.data.map((obj) => {
            newWarehouseAllMap[obj.externalWareId] = !obj.geolocation;
            if (!obj.latitude && !obj.longitude) {
              newWarehouseAllMap[obj.externalWareId] = true;
            }
          });
        });
        setWarehouseAllMap(newWarehouseAllMap);
        setData(promiseMap);
        return {
          warehouseChannelLoading: loading,
          warehouseChannel: data,
          warehouseAllMap,
          fetchWarehouseChannel: fetchData
        };
      } else if (shopId) {
        let defaultData = await defaultAxios.post(`/saas/shop/get-shop-warehouse-by-channel-shop`, {
          shopId,
          channel: "BLIBLI_ID"
        });
        let promiseMap = {};
        let promiseAllMap = {};
        promiseAllMap[shopId] = defaultData.data;
        let newWarehouseAllMap = {};
        promiseMap[shopId] = defaultData.data.map((obj) => {
          newWarehouseAllMap[obj.externalWareId] = !obj.geolocation;
          if (!obj.latitude && !obj.longitude) {
            newWarehouseAllMap[obj.externalWareId] = true;
          }
          return obj;
        });
        setWarehouseAllMap(newWarehouseAllMap);
        setData({...data, ...promiseMap});
        return {
          warehouseChannelLoading: loading,
          warehouseChannel: data,
          warehouseAllMap,
          fetchWarehouseChannel: fetchData
        };
      } else {
        setData({});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    warehouseChannelLoading: loading,
    warehouseChannel: data,
    warehouseAllMap,
    fetchWarehouseChannel: fetchData
  };
};
export const getWarehouseChannelModel = createModel(getWarehouseChannel);
export const pullShopWarehouse = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {fetchWarehouseChannel} = getWarehouseChannelModel();
  const fetchData = async (params) => {
    setLoading(true);
    let {data: data2} = await defaultAxios.post(`/saas/shop/pull-shop-warehouse-by-channel-and-shop`, params);
    if (data2) {
      let fetchData2 = await fetchWarehouseChannel([], params.shopId);
      if (fetchData2) {
        setLoading(false);
      }
    }
    setData(data2);
  };
  return {
    pullShopWarehouseLoading: loading,
    pullShopWarehouse: data,
    fetchPullShopWarehouse: fetchData
  };
};
export const pullShopWarehouseModel = createModel(pullShopWarehouse);
export const pullLogistics = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {fetchBlibliLogistics} = getSaasShopLogisticsShopModel();
  const fetchData = async (params) => {
    setLoading(true);
    let {data: data2} = await defaultAxios.post(`/saas/shop/pull-logistics-by-channel-and-shop`, params);
    if (data2) {
      let fetchData2 = await fetchBlibliLogistics([], params.shopId);
      if (fetchData2) {
        setLoading(false);
      }
    }
    setData(data2);
  };
  return {
    pullLogisticsLoading: loading,
    pullLogistics: data,
    fetchPullLogistics: fetchData
  };
};
export const pullLogisticsModel = createModel(pullLogistics);
export const pullProductBrand = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {fetchBlibliBrands} = useGetBrandsByChannelModel();
  const fetchData = async (search, shopId) => {
    setLoading(true);
    let data2 = await request.post(`/infra/shop/sync/pull-data-from-channel`, {
      syncDataType: "CHANNEL_BRAND",
      syncAction: "FULLY_SYNC",
      genieShopId: shopId,
      syncSource: "MANUALLY_FROM_ERP",
      dataIdList: []
    }, {
      handleError: (error) => {
        notification.error({
          message: "Tips",
          description: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
            style: {wordBreak: "break-all"}
          }, error.message), /* @__PURE__ */ React.createElement("div", {
            style: {
              textAlign: "right",
              marginTop: 8,
              marginBottom: 8,
              opacity: 0.5,
              color: "#333",
              fontSize: "12px"
            }
          }, error.transactionId))
        });
        console.error("error", error.message, error.transactionId);
        setLoading(false);
      }
    });
    if (data2) {
      let fetchData2 = await fetchBlibliBrands({
        channel: "BLIBLI_ID",
        country: "ID",
        prefix: search || ""
      });
      if (fetchData2) {
        setLoading(false);
      }
    }
    setData(data2);
  };
  return {
    pullProductBrandLoading: loading,
    pullProductBrand: data,
    fetchPullProductBrand: fetchData
  };
};
export const pullProductBrandModel = createModel(pullProductBrand);
export const getSaasProductShopCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/shop/get-categories`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const resetData = async () => {
    setData([]);
  };
  return {
    blibliCategoriesLoading: loading,
    blibliCategories: data,
    blibliResetCategories: resetData,
    fetchBlibliCategories: fetchData
  };
};
export const getSaasProductShopCategoriesModel = createModel(getSaasProductShopCategories);
export const getCategoryAttributesChannel = () => {
  const [data, setData] = useState();
  const [mandatoryData, setMandatoryData] = useState([]);
  const [allAttributeIdMap, setAllAttributeIdMap] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/shop/get-categoryAttributes-by-channel`, params);
      let newDataMap = {};
      let newDataMapName = {};
      data2.map((data3, index) => {
        newDataMap[data3.attributeId] = data3;
        newDataMapName[data3.attributeName] = data3;
      });
      let newData = [];
      let attributeIdMap = {};
      let toryData = [];
      data2.map((data3, index) => {
        if (data3?.mandatory && !data3?.variantCreating && !data3?.specialAttribute) {
          toryData = [...toryData, data3];
        } else if (data3?.mandatory && data3?.variantCreating && !data3?.specialAttribute) {
          toryData = [...toryData, data3];
        } else if (data3?.attributeName === "Warna" && data3?.variantCreating && newDataMap[data3.attributeId]) {
          newData = [...newData, data3];
          let newOptions = [];
          if (newDataMapName["Family Colour"] && newDataMapName["Family Colour"].options) {
            data3["type"] = "INPUT_SELECT";
            newOptions = newDataMapName["Family Colour"].options.map((oData) => {
              return {
                value: oData
              };
            });
          }
          data3["options"] = newOptions;
        } else if (data3?.variantCreating) {
          newData = [...newData, data3];
        }
        attributeIdMap[data3.attributeId] = data3;
      });
      setData(newData);
      setMandatoryData(toryData);
      setAllAttributeIdMap(attributeIdMap);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const resetData = () => {
    setData(void 0);
    setAllAttributeIdMap({});
    setMandatoryData([]);
  };
  return {
    categoriesAttributesLoading: loading,
    categoriesAttributes: data,
    resetCategoriesAttributes: resetData,
    mandatoryData,
    allAttributeIdMap,
    fetchCategoriesAttributes: fetchData
  };
};
export const getCategoryAttributesChannelModel = createModel(getCategoryAttributesChannel);
export const saasProductCreateProduct = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/create-product`, {
        params
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    createProductLoading: loading,
    createProduct: data,
    fetchCreateProduct: fetchData
  };
};
export const saasProductCreateProductModel = createModel(saasProductCreateProduct);
export const useProductBlibli = () => {
  const [data, setData] = useState(void 0);
  const [loading, setLoading] = useState(false);
  const fetchData = async (productId) => {
    setLoading(true);
    try {
      let param = {
        productId,
        channelId: "BLIBLI_ID"
      };
      const {data: data2} = await axios.post(`/saas/product/get-product`, {
        ...param
      });
      setData({...data2, shopIds: [data2?.shopId]});
      return {
        productInfo: data2
      };
    } catch (error) {
      handleError(error);
      return {
        productInfo: {}
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    productInfoLoading: loading,
    productInfoMsg: data,
    fetchProductInfo: fetchData
  };
};
export const useProductBlibliModel = createModel(useProductBlibli);
